import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  toggleDamzPage,
  toggleBurgerMenuRequested,
  openDamzDropdown,
  closeDamzDropdown,
} from '../../redux/actions';
import { Props } from './DamzDropdownWrapper';
import {
  getDamzHeaderCount,
  getDamzHeaderRequestsCount,
  getIsDamzDropdownOpen,
  getIsDamzPageOpen,
} from '../../redux/selectors';

type StateProps = Pick<
  Props,
  | 'unreadCount'
  | 'isDamzDropdownOpen'
  | 'isDamzPageOpen'
  | 'unreadRequestsCount'
>;
type DispatchProps = Pick<
  Props,
  | 'toggleDamzPage'
  | 'toggleBurgerMenu'
  | 'openDamzDropdown'
  | 'closeDamzDropdown'
>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  isDamzPageOpen: getIsDamzPageOpen(state),
  unreadCount: getDamzHeaderCount(state),
  unreadRequestsCount: getDamzHeaderRequestsCount(state),
  isDamzDropdownOpen: getIsDamzDropdownOpen(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  toggleDamzPage,
  toggleBurgerMenu: toggleBurgerMenuRequested,
  openDamzDropdown,
  closeDamzDropdown,
};

export default connect(mapStateToProps, mapDispatchToProps);
